export type WeekdayData = {
  id: string | number;
  monday?: number;
  tuesday?: number;
  wednesday?: number;
  thursday?: number;
  friday?: number;
  saturday?: number;
  sunday?: number;
};

export type EntityDataItem = {
  id?: number;
  capacity?: { averageCapacityPerformancePerWeekday?: Record<string, number> };
};

export type GetLabelName = (index: number) => string;

export function buildWeekdayChartData(
  data: EntityDataItem[],
  currentFloors: { id: number; open: boolean }[],
  selectedZoneOrWorkplace: { open: boolean; name: string | string[] } | null | undefined,
  getLabelName: GetLabelName
): WeekdayData[] {
  if (!data?.length) return [];
  const weekday = (d: EntityDataItem) => d?.capacity?.averageCapacityPerformancePerWeekday;
  if (selectedZoneOrWorkplace?.open) {
    const name = selectedZoneOrWorkplace.name;
    const id = Array.isArray(name) ? name.join(", ") : name;
    return data.map(d => ({
      id,
      monday: weekday(d)?.monday,
      tuesday: weekday(d)?.tuesday,
      wednesday: weekday(d)?.wednesday,
      thursday: weekday(d)?.thursday,
      friday: weekday(d)?.friday,
      saturday: weekday(d)?.saturday,
      sunday: weekday(d)?.sunday
    }));
  }
  const firstFloorId = currentFloors[0]?.id as number | undefined;
  const secondFloorId = currentFloors[1]?.id as number | undefined;
  const items = [
    firstFloorId == null ? undefined : data.find(d => d?.id === firstFloorId),
    secondFloorId == null ? undefined : data.find(d => d?.id === secondFloorId)
  ].filter((d): d is NonNullable<typeof d> => d != null);
  return items.map((d, index) => ({
    id: getLabelName(index) || String(d?.id ?? ""),
    monday: weekday(d)?.monday,
    tuesday: weekday(d)?.tuesday,
    wednesday: weekday(d)?.wednesday,
    thursday: weekday(d)?.thursday,
    friday: weekday(d)?.friday,
    saturday: weekday(d)?.saturday,
    sunday: weekday(d)?.sunday
  }));
}
